import React from 'react'
import { Link, Outlet } from 'react-router-dom'
import { FaUserPlus } from "react-icons/fa6";
import './UserHeader.scss'
import { BsChatDots } from 'react-icons/bs';
import { IoMdNotificationsOutline } from 'react-icons/io';
import { MdEventAvailable, MdOutlineSpeakerNotes } from 'react-icons/md';
import { IoHomeOutline, IoMenuSharp } from 'react-icons/io5';


function UserHeader() {
    return (
        <>
            <div className="header-container">
                <div className=" container-xl container-fluid">
                    <div className="row py-2 d-flex justify-content-between align-items-center">

                        <div className="rideHire col-xl-1 col-2">
                            <h4>RideHire</h4>
                        </div>

                        <div className="col-xl-8 col-7 d-md-block d-none">

                            <div className="d-flex justify-content-center align-items-center " >
                                <ul className='w-100 list-unstyled d-flex justify-content-evenly align-items-center m-0'>
                                    <li>Dashboard</li>
                                    <li>Location</li>
                                    <li>Wishlist</li>
                                    <li>Chat</li>
                                    <li>Profile</li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-xl-3 col-3 d-md-block d-none">

                            <div className="sign-column d-flex align-items-center gap-3">
                                <Link className='text-decoration-none fw-medium text-black d-lg-block d-none list-head-text' >List Your Vehical</Link>
                                <div className="signUp-btn1 px-2">
                                    <div className="d-flex align-items-center p-2 gap-1 text-white ">
                                        <FaUserPlus />
                                        <Link to={'/userRegister'} className="signup-txt fw-medium text-white text-decoration-none">Signup/Login</Link>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-10 d-flex justify-content-end">
                            <div className="d-md-none d-block ">
                                <button
                                    className="btn p-0 text-black border-0 fs-5"
                                    type="button"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasExample"
                                    aria-controls="offcanvasExample"
                                >
                                    <IoMenuSharp />
                                </button>
                                <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                                    <div className="offcanvas-header" >
                                        <div className="side-navbar" style={{ width: "200px" }}>
                                            <ul className="list-unstyled d-flex flex-column justify-content-center">
                                                <li className="d-flex align-items-center text-white">
                                                    <a href="/host/home" className="text-white d-flex align-items-center text-decoration-none">
                                                        <div>
                                                            <img srcSet={require('../Assests/Logo.png')} className="mt-4 w-100" alt="Logo" />
                                                        </div>
                                                        <span className="text pt-4 ms-2 d-flex justify-content-center">
                                                            <h3>RideHire</h3>
                                                        </span>
                                                    </a>
                                                </li>
                                                <li className="mt-3">
                                                    <Link to={"/home"} className="text-decoration-none">
                                                        <span className="fs-4 text-white"><IoHomeOutline /></span>
                                                        <span className="fs-6 ms-4 text-white">Dashboard</span> {/* Always visible */}
                                                    </Link>
                                                </li>
                                                <li className="mt-2">
                                                    <Link className="text-decoration-none">
                                                        <span className="fs-4 text-white"><MdOutlineSpeakerNotes /></span>
                                                        <span className="fs-6 ms-4 text-white">Location</span>
                                                    </Link>
                                                </li>
                                                <li className="mt-2">
                                                    <Link to={"/calendar"} className="text-decoration-none">
                                                        <span className="fs-4 text-white"><MdEventAvailable /></span>
                                                        <span className="fs-6 ms-4 text-white">Wishlist</span>
                                                    </Link>
                                                </li>
                                                <li className="mt-2">
                                                    <Link className="text-decoration-none">
                                                        <span className="fs-4 text-white"><IoMdNotificationsOutline /></span>
                                                        <span className="fs-6 ms-4 text-white">Chat</span>
                                                    </Link>
                                                </li>
                                                <li className="mt-2">
                                                    <Link className="text-decoration-none">
                                                        <span className="fs-4 text-white"><BsChatDots /></span>
                                                        <span className="fs-6 ms-4 text-white">Profile</span>
                                                    </Link>
                                                </li>
                                                <li className='mt-2 justify-content-center'>
                                                    <div className="sign-column d-flex align-items-center  gap-3">
                                                        <div className="signUp-btn px-2">
                                                            <div className="d-flex align-items-center p-2 gap-1 text-white ">
                                                                <FaUserPlus />
                                                                <div className="signup-txt fw-medium">Signup/Login</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="mt-auto d-flex jusify-content-center">
                                                    <Link className="text-decoration-none">
                                                        <span className="fs-6 text-white d-flex justify-content-center">Logout</span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <div className="">
                <Outlet />
            </div>

        </>
    )
}

export default UserHeader